<template lang="pug">
  .c-popup(v-show="param.popup" @click="param.popup = false")
    .c-popup__operate.col-24.color-white.flexD.flexDirectionRow.justifySpaceBetween.alignItemsCenter.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .width10EM
      .flexD.flexDirectionRow.alignItemsCenter.font-title
        .width2EM.textAlignCenter
          i.fa.fa-arrow-left.cursorPointer(@click="prevPage" v-if="param.index > 0")
        .width2EM.textAlignCenter
          i.fa.fa-close.cursorPointer(@click="param.popup = false")
        .width2EM.textAlignCenter
          i.fa.fa-arrow-right.cursorPointer(@click="nextPage" v-if="param.index < arr.length - 1")
      a.cursorPointer.font-section.width10EM.color-white.textDecorationNone(:href="pdf" target="_blank" download)
        i.fa.fa-download.lineHeight2EM(style="font-size: 1.5em")
    .c-popup__content.m-width-90.m-maxWidthNone(@click="stopPropagation($event)")
      .col-24.bgColor-white.textAlignLeft.flexD.flexDirectionRow.justifySpaceBetween.m-flexDirectionColumn
        .col-11.m-width-100
          .col-24(v-for="(item, index) in arr[param.index].left" :key="index")
            .col-24.font-title.m-margin-bottom-1em(v-if="item.type == 'title'") {{ item.content }}
            .col-24.font-section.l-margin-bottom-2em(v-if="item.type == 'des'") {{ item.content }}
            .col-24.l-margin-bottom-1em(v-if="item.type == 'list'" v-for="(t, i) in item.content" :key="i")
              .font-title-middle.color-title-green.fontBold {{ t.title }}
              .font-section {{ t.content }}
        .col-11.m-width-100.m-flex.m-flexDirectionColumnReverse
          .col-24(v-for="(item, index) in arr[param.index].right" :key="index")
            .col-24.l-margin-bottom-1em.msFlexNegative(v-if="item.type == 'video'")
              video.block.col-24(:src="item.url" controls="controls" :poster="item.poster")
            .col-24.l-margin-bottom-1em(v-if="item.type == 'list'" v-for="(t, i) in item.content" :key="i")
              .font-title-middle.color-title-green.fontBold {{ t.title }}
              .font-section {{ t.content }}

</template>

<script>
  export default {
    name: 'popupPressalit',
    props: ['content'],
    data(){
      return{
        param: {
          popup: false,
          index: 0
        },
        pdf: "./doc/pressalit.pdf",
        arr: [
          {
            left: [
              { type: 'title', content: this.$t('pressalit_popup.item_1.title')},
              { type: 'des', content: this.$t('pressalit_popup.item_1.content') },
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_1.items.title_1'), content: this.$t('pressalit_popup.item_1.items.content_1') },
                { title: this.$t('pressalit_popup.item_1.items.title_2'), content: this.$t('pressalit_popup.item_1.items.content_2') },
                { title: this.$t('pressalit_popup.item_1.items.title_3'), content: this.$t('pressalit_popup.item_1.items.content_3') },
              ] },

            ],
            right: [
              {type: 'video', url: require('@/assets/media/pressalit_1.mp4'), poster: require('@/assets/img/cover_pressalit_1.jpg')},
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_1.items.title_4'), content: this.$t('pressalit_popup.item_1.items.content_4') },
                { title: this.$t('pressalit_popup.item_1.items.title_5'), content: this.$t('pressalit_popup.item_1.items.content_5') },
                { title: this.$t('pressalit_popup.item_1.items.title_6'), content: this.$t('pressalit_popup.item_1.items.content_6') },
              ] },
            ],
          },
          {
            left: [
              { type: 'title', content: this.$t('pressalit_popup.item_2.title')},
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_2.items.title_1'), content: this.$t('pressalit_popup.item_2.items.content_1') },
                { title: this.$t('pressalit_popup.item_2.items.title_2'), content: this.$t('pressalit_popup.item_2.items.content_2') },
                { title: this.$t('pressalit_popup.item_2.items.title_3'), content: this.$t('pressalit_popup.item_2.items.content_3') },
              ] },

            ],
            right: [
              {type: 'video', url: require('@/assets/media/pressalit_2.mp4'), poster: require('@/assets/img/cover_pressalit_2.jpg')},
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_2.items.title_4'), content: this.$t('pressalit_popup.item_2.items.content_4') },
                { title: this.$t('pressalit_popup.item_2.items.title_5'), content: this.$t('pressalit_popup.item_2.items.content_5') },
                { title: this.$t('pressalit_popup.item_2.items.title_6'), content: this.$t('pressalit_popup.item_2.items.content_6') },
              ] },
            ],
          },
          {
            left: [
              { type: 'title', content: this.$t('pressalit_popup.item_3.title')},
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_3.items.title_1'), content: this.$t('pressalit_popup.item_3.items.content_1') },
                { title: this.$t('pressalit_popup.item_3.items.title_2'), content: this.$t('pressalit_popup.item_3.items.content_2') },
              ] },

            ],
            right: [
              {type: 'video', url: require('@/assets/media/pressalit_3.mp4'), poster: require('@/assets/img/cover_pressalit_3.jpg')},
            ],
          },
          {
            left: [
              { type: 'title', content: this.$t('pressalit_popup.item_4.title')},
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_4.items.title_1'), content: this.$t('pressalit_popup.item_4.items.content_1') },
                { title: this.$t('pressalit_popup.item_4.items.title_2'), content: this.$t('pressalit_popup.item_4.items.content_2') },
                { title: this.$t('pressalit_popup.item_4.items.title_3'), content: this.$t('pressalit_popup.item_4.items.content_3') },
              ] },

            ],
            right: [
              {type: 'video', url: require('@/assets/media/pressalit_4.mp4'), poster: require('@/assets/img/cover_pressalit_4.jpg')},
              { type: 'list', content: [
                { title: this.$t('pressalit_popup.item_4.items.title_4'), content: this.$t('pressalit_popup.item_4.items.content_4') },
                { title: this.$t('pressalit_popup.item_4.items.title_5'), content: this.$t('pressalit_popup.item_4.items.content_5') },
                { title: this.$t('pressalit_popup.item_4.items.title_6'), content: this.$t('pressalit_popup.item_4.items.content_6') },
              ] },
            ],
          },
        ],
      }
    },
    computed: {},
    watch: {
      content(data) {
        this.param = data
      }
    },
    methods:{
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
      prevPage(){
        this.param.index -= 1
      },
      nextPage(){
        this.param.index += 1
      }
    },
    created(){}
  }
</script>
